import React from 'react';
import {useContextSelector} from 'use-context-selector';
import Loader from './Loader';
import CookiesNotice from './CookiesNotice';
// import Introduction from './Introduction';
// import Registration from './Registration';
// import Login from './Login';

import {LocalContext} from '../context/LocalContext';
// import {SessionContext} from '../context/SessionContext';

const Modals = (props) => {
    const cookiesPolicyAccepted = useContextSelector(LocalContext, v => v[0].cookiesPolicy.accepted);
    // const modeIntroduction = useContextSelector(SessionContext, v => v[0].modeIntroduction);
    // const modeRegistration = useContextSelector(SessionContext, v => v[0].modeRegistration);
    // const modeLogin = useContextSelector(SessionContext, v => v[0].modeLogin);

    return <>
        {!cookiesPolicyAccepted ?
            <Loader>
                <CookiesNotice />
            </Loader> :
            <>
                {/* {modeRegistration ? */}
                {/*     <Loader> */}
                {/*         <Registration /> */}
                {/*     </Loader> : null} */}
                {/* {modeLogin ? */}
                {/*     <Loader> */}
                {/*         <Login /> */}
                {/*     </Loader> : null} */}
                {/* {modeIntroduction ? */}
                {/*     <Loader> */}
                {/*         <Introduction /> */}
                {/*     </Loader> : null} */}
            </>
        }
    </>
}

export default Modals;
